module.exports = __webpack_public_path__ + "2416265dd4725841de4a0e620c204b10.svg";